module.exports = __webpack_public_path__ + "img/101-j-8.prt.ba27fac0.jpg";